module.exports = __webpack_public_path__ + "static/media/barre.694292c9.svg";